import { render, staticRenderFns } from "./terms-condition.vue?vue&type=template&id=ab04807e&scoped=true&"
var script = {}
import style0 from "./terms-condition.vue?vue&type=style&index=0&id=ab04807e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab04807e",
  null
  
)

export default component.exports